import { DateFilter } from "./DateFilter";
import { Filter } from "./Filter";
import { TextMatchFilter } from "./TextMatchFilter";

export class FilterFactory
{
  static create( filterSetting:Element ):Filter
  {
    if ( DateFilter.type.in( filterSetting ) )
    {
      return new DateFilter( filterSetting );
    }

    if ( TextMatchFilter.type.in( filterSetting ) )
    {
      return new TextMatchFilter( filterSetting );
    }

    return null;
  }
}